import { useMutation } from '@tanstack/react-query'
import { APIInstance } from '@/utils/functions/instance'
import { TPostApiRequestType } from './type'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

export function useSubmitAddress({
  disableToast,
  ...rest
}: IApiBaseTypes<TPostApiRequestType>) {
  return useMutation({
    mutationFn: async (data: TPostApiRequestType) => {
      const response = await APIInstance<IResponseType<TPostApiRequestType>>({
        url: 'mrf/address/',
        method: 'post',
        data
      })
      return response.data
    },
    retry: 0,
    mutationKey: ['submitAddress'],
    ...rest
  })
}
